import SettingsSearchTarget from '@/components/Settings/SettingsSearchTarget';
import React, { useState } from 'react';
import { StyleSheet, View } from 'react-native';
import Text from '@/components/Typography/Text';
import { useTheme } from '@/context/ThemeContext';
import useResponsiveness from '@/hooks/useResponsiveness';

export function SettingsCardGroup({ title, children }) {
  const { colors } = useTheme();
  return <View style={styles.group}>
    {!!title && <Text size="s" weight="semibold" color="secondary" accessibilityRole="header" accessibilityLevel={2} style={styles.heading}>{title}</Text>}
    <View style={[styles.card, { backgroundColor: colors.solid_color_block, borderColor: colors.border_color_secondary }]}>
      {children}
    </View>
  </View>;
}

export function SettingsCardRow({ title, subtitle, children, isFirst = false, titleAccessory, compact = false }) {
  const { colors } = useTheme();
  const { isXS } = useResponsiveness();
  const [width, setWidth] = useState(0);
  const stacked = !compact && (width ? width < 560 : isXS);
  return <SettingsSearchTarget label={title} accessibilityLabel={`${title} section`} onLayout={event => setWidth(event.nativeEvent.layout.width)} style={[
    styles.row, { borderTopColor: colors.border_color_secondary },
    isFirst && { borderTopWidth: 0 },
    stacked && { flexDirection: 'column', alignItems: 'stretch' },
  ]}>
    <View style={styles.copy}>
      <View style={styles.title}>
        <Text weight="medium" style={{ flexShrink: 1 }}>{title}</Text>
        {titleAccessory}
      </View>
      {!!subtitle && <Text size="s" color="secondary" style={styles.description}>{subtitle}</Text>}
    </View>
    <View style={[styles.control, stacked && { alignSelf: 'flex-start' }]}>{children}</View>
  </SettingsSearchTarget>;
}

const styles = StyleSheet.create({
  group: { marginBottom: 24 },
  heading: { marginLeft: 4, marginBottom: 10 },
  card: { borderWidth: 1, borderRadius: 16 },
  row: { flexDirection: 'row', alignItems: 'center', gap: 20, padding: 20, borderTopWidth: StyleSheet.hairlineWidth },
  copy: { flex: 1, minWidth: 0, gap: 5 },
  title: { flexDirection: 'row', alignItems: 'center', flexWrap: 'wrap', gap: 8 },
  description: { lineHeight: 21 },
  control: { flexShrink: 1, maxWidth: '100%' },
});
